<template>
  <div class="page">
    <div class="query-conditions">
      <el-form :inline="true">
        <el-form-item>
          <el-input
            v-model="query.form.keyword"
            clearable
            placeholder="请输入广告主公司名称/帐号/编号/合作产品"
            style="min-width: 350px"
            @keyup.enter.native="handleFilter"
          />
        </el-form-item>
        <el-form-item>
          <!-- <el-select clearable v-model="query.form.step_id" placeholder="业务阶段">
                        <el-option v-for="item in listSteps" :key="item.id" :value="item.id" :label="item.name">
                        </el-option>
                    </el-select> -->
          <el-cascader
            ref="category-cascader"
            :options="listSteps"
            :props="{ checkStrictly: true, expandTrigger: 'hover' }"
            clearable
            placeholder="业务阶段"
            @change="handleStepsChange"
          >
            <template slot-scope="{ node, data }">
              <span
                style="display:block;"
                @click="handleSelectCate(node, data)"
              >
                {{ data.label }}
              </span>
            </template>
          </el-cascader>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="query.form.audit"
            clearable
            placeholder="审核结果"
          >
            <el-option
              v-for="item in auditResults"
              :key="item.id"
              :value="item.id"
              :label="item.text"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="query.form.order_by"
            clearable
            placeholder="排序方式"
            style="min-width: 210px"
          >
            <el-option
              v-for="item in privateListSort"
              :key="item.id"
              :value="item.id"
              :label="item.text"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            style="width: 132px; border-color: #2F9EFF; color: #2F9EFF; background: #fff;"
            plain
            type="primary"
            :loading="table.loading"
            @click="handleFilter"
          >
            查询
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div
      v-if="canpublicList"
      v-loading="table.loading"
      class="query-data"
    >
      <!-- list -->
      <div
        v-if="table.list.length > 0"
        class="query-table"
      >
        <div class="query-list">
          <div
            v-for="(item, index) in table.list"
            :key="index"
            class="list-item"
          >
            <!-- item -->
            <div class="item-body">
              <Item
                :item="item"
                :brands="brands"
                @import-succ="onImportSucc"
                @update-step-succ="onUpdateStepSucc"
              />
            </div>
          </div>
        </div>

        <el-pagination
          :current-page.sync="query.form.page"
          :page-sizes="[20, 30, 50, 100]"
          layout="total, sizes, prev, pager, next"
          :total="table.total"
          style="margin-top: 16px; float: right"
          @size-change="handlePageSizeChange"
          @current-change="handleQueryPage"
        />
      </div>

      <!-- no-data -->
      <Empty
        v-else
        tips="没有查询到广告主哦～"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Empty from '@/components/Empty';
import Item from './components/Item';
import Request from '@/core/QuRequest';
import { auditResults, privateListSort, listSteps } from '../conf';

const req = new Request();

export default {
  name: 'AdvertiserManagePrivate',
  components: { Item, Empty },
  props: {
    steps: {
      type: Array,
      required: true,
      default: () => [],
    },
    brands: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      auditResults,
      privateListSort,
      listSteps,
      table: {
        list: [],
        total: 0,
        loading: false,
      },
      query: {
        form: {
          keyword: '',
          step_id: '',
          audit: '',
          order_by: 2,
          page: 1,
          page_size: 20,
        },
        rule: {},
      },
    };
  },
  computed: {
    ...mapState(['sysUser']),

    perms() {
      return this.$store.state.perms;
    },

    canpublicList() {
      return this.perms.includes('publicList');
    },
  },
  created() {
    this._getList();
  },
  methods: {
    // 获取列表数据
    async _getList() {
      try {
        let form = this.query.form;
        const params = {
          page: form.page,
          page_size: form.page_size,
        };
        !!form.keyword && (params.keyword = form.keyword);
        !!form.step_id && (params.step_id = form.step_id);
        !!form.audit && (params.audit = form.audit);
        !!form.order_by && (params.order_by = form.order_by);

        this.table.loading = true;
        // req
        const res = await req
          .send(req.Apis.sales.customerStage2.publicList, params)
          .fin(() => {
            this.table.loading = false;
          });
        this.table.list = [...(res.data.data || [])];
        this.table.total = Number(res.data.total || 0);
      } catch (err) {
        this.$message.error(`获取列表失败：${err.message || '未知错误'}`);
      }
    },

    handleStepsChange(valArr = []) {
      if (valArr.length === 0) {
        this.query.form.step_id = '';
      } else {
        this.query.form.step_id = valArr[valArr.length - 1];
      }
    },

    handleSelectCate(node) {
      const panel = this.$refs['category-cascader'].panel;
      panel.handleCheckChange(node.path);
      panel.handleExpand(node);
    },

    // 筛选
    handleFilter() {
      this.query.form.page = 1;
      this._getList();
    },

    // 页量改变
    handlePageSizeChange(pageSize) {
      this.query.form.page_size = Number(pageSize);
      this._getList();
    },

    // 页码改变
    handleQueryPage(page) {
      this.query.form.page = Number(page);
      this._getList();
    },

    // 转化status
    exStatus(st) {
      return {
        id: Number(st),
        text: (auditResults.find((i) => i.id === Number(st)) || {}).text,
      };
    },

    // 监听更新状态完成
    onUpdateStepSucc() {
      // 触发一次查询, 后续可处理为前端层更新（非接口处理）
      this.handleFilter();
    },

    // 监听导入私海成功
    onImportSucc() {
      // 触发一次查询, 后续可处理为前端层更新UI,减少非必要查询
      this.handleFilter();
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-form-item {
  margin-bottom: 24px;
  margin-right: 24px;
}
.query-data {
  /deep/ .el-tag {
    height: 24px;
    line-height: 22px;
  }
  /deep/ .el-button--medium {
    padding: 9px 24px;
    font-size: 12px;
  }
  // table
  .query-table {
    position: relative;
    overflow: hidden;

    .list-item {
      position: relative;
      border-radius: 4px;
      border: 1px solid rgba(220, 223, 230, 1);
      padding: 28px 28px 32px 28px;
      margin-bottom: 24px;
      &:last-child {
        margin-bottom: 0;
      }

      .item-status {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
      }
    }
  }
}
</style>
